import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { TreatmentsHistoryBottomPanel } from './TreatmentsHistoryBottomPanel.component'

const withUnmountHoc = withUnmountTransition(TreatmentsHistoryBottomPanel)
export { withUnmountHoc as TreatmentsHistoryBottomPanel }
